module.exports = __webpack_public_path__ + "static/media/galerija_2021 (6)-min.062e2a87.jpg";